import { MSerializers } from "@legacy-megarax/serializers";

import { gtinSerializer } from "../../common";
import { PriceListChangeDto, UserReferenceWithEmail } from "../read/detail";

const userReferenceWithEmailSerializer = MSerializers.object<UserReferenceWithEmail>({
  id: MSerializers.integer,
  email: MSerializers.optional(MSerializers.string.nullable()),
});

export const priceListChangeDtoSerializer = MSerializers.object<PriceListChangeDto>({
  uuid: MSerializers.uuid(),
  activeFrom: MSerializers.datetime,
  approvedAt: MSerializers.datetime,
  approvedBy: userReferenceWithEmailSerializer,
  comment: MSerializers.string,
  gtin: gtinSerializer,
  netPrice: MSerializers.decimal.nullable(),
  proposedAt: MSerializers.datetime,
  proposedBy: userReferenceWithEmailSerializer,
});
